import ReactIcon from '@ant-design/icons-react';
export function setTwoToneColor(primaryColor) {
    return ReactIcon.setTwoToneColors({
        primaryColor: primaryColor
    });
}
export function getTwoToneColor() {
    var colors = ReactIcon.getTwoToneColors();
    return colors.primaryColor;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@3.10.1@antd/es/icon/twoTonePrimaryColor.js
// module id = 775
// module chunks = 0